import React, { useState, useRef, useEffect } from 'react';
import { statusWithDays, isAway } from './statusUtils.js';

const UserAvatar = ({ user, size = 40 }) => {
  const [showStatus, setShowStatus] = useState(false);
  const ref = useRef(null);

  // Закрытие подсказки при клике вне аватарки
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setShowStatus(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const away = isAway(user);
  const statusText = statusWithDays(user);
  const name = user?.displayName || (user?.email ? user.email.split('@')[0] : 'Пользователь');

  const baseStyle = {
    width: size, height: size, borderRadius: '50%', cursor: 'pointer',
    opacity: away ? 0.45 : 1,
    filter: away ? 'grayscale(60%)' : 'none',
    transition: 'opacity 0.3s, filter 0.3s',
  };

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      {user?.photoURL ? (
        <img
          src={user.photoURL}
          alt="avatar"
          onClick={() => setShowStatus((v) => !v)}
          style={{ ...baseStyle, objectFit: 'cover' }}
        />
      ) : (
        <div
          onClick={() => setShowStatus((v) => !v)}
          style={{
            ...baseStyle,
            background: 'linear-gradient(135deg,#667eea,#764ba2)',
            color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 'bold', fontSize: size * 0.42,
          }}
        >
          {name.charAt(0).toUpperCase()}
        </div>
      )}

      {showStatus && (
        <div style={{
          position: 'absolute', top: size + 8, left: '50%', transform: 'translateX(-50%)',
          background: '#1e3c72', color: '#fff', padding: '8px 12px', borderRadius: '8px',
          fontSize: '12px', whiteSpace: 'nowrap', zIndex: 200,
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        }}>
          <strong>{name}</strong>
          <div style={{ marginTop: '4px' }}>
            {away ? '🔴 ' : '🟢 '}{statusText}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAvatar;